__turbopack_context__.v({
  "container": "style-module-scss-module__MTBILq__container",
  "image": "style-module-scss-module__MTBILq__image",
  "media": "style-module-scss-module__MTBILq__media",
  "section": "style-module-scss-module__MTBILq__section",
  "tag": "style-module-scss-module__MTBILq__tag",
  "tags": "style-module-scss-module__MTBILq__tags",
  "text": "style-module-scss-module__MTBILq__text",
  "title": "style-module-scss-module__MTBILq__title",
  "video": "style-module-scss-module__MTBILq__video",
});
